export const styles = {
  button: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#EDEDED",
    borderRadius: "100px",
    padding: "3px 8px 3px 12px",
    border: "1px solid #EDEDED",
  },
  buttonOpen: {
    border: "1px solid #393939",
  },
};
